import { Component, computed, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeCover } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { HeroVImagesComponent } from '@app/components/hero-v-images/hero-v-images.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-cover',
  templateUrl: './node-cover.component.html',
  styleUrls: ['./node-cover.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    HeroVImagesComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeCoverComponent {
  readonly entity = input.required<NodeCover>();

  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
